module.exports = __webpack_public_path__ + "img/26.9f2bae1.jpg";